import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from './layout.component';
import {RouterModule} from '@angular/router';
import {FooterComponent} from '@app/modules/layout/footer/footer.component';
import {HeaderComponent} from '@app/modules/layout/header/header.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {ToggleMenuOnHoverDirective} from './header/toggle-menu-on-hover-directive.directive';
import {SharedModule} from '@app/shared/shared.module';
import {MatListModule} from '@angular/material/list';
import {MobileMenuComponent} from './mobile-menu/mobile-menu.component';
import {NavigationComponent} from './navigation/navigation.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {ShoppingCartComponent} from '@app/modules/layout/shopping-cart/shopping-cart.component';
import { ShoppingCartItemComponent } from './shopping-cart/shopping-cart-item/shopping-cart-item.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';
import { ShoppingCartToggleComponent } from './shopping-cart/shopping-cart-toggle/shopping-cart-toggle.component';


@NgModule({
	declarations: [
		LayoutComponent,
		FooterComponent,
		HeaderComponent,
		ToggleMenuOnHoverDirective,
		MobileMenuComponent,
		NavigationComponent,
		ShoppingCartComponent,
		ShoppingCartItemComponent,
		ShoppingCartToggleComponent
	],
	exports: [
		LayoutComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		MatToolbarModule,
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatDividerModule,
		SharedModule,
		MatListModule,
		MatSidenavModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatBadgeModule
	]
})
export class LayoutModule {
}
